import { Injectable } from '@angular/core';
import { EventBus } from '../event-bus';

export type UserEventBusSignalREvents =
  | '[User] initialized'
  | '[User] import-progress'
  | '[User] export-progress'
  | '[User] clash-detection-progress'
  | '[User] send-message';

/**
 * UserEventBus is responsible for emitting and listening to user-related events across the application.
 * Its provided on root level ensures that all modules share the same instance, allowing for seamless communication of user events.
 */
@Injectable({
  providedIn: 'root',
})
export class UserEventBus extends EventBus<UserEventBusSignalREvents> {}
